import gql from 'graphql-tag';

export const getExams = gql`
  query Exams($period: String!) {
    exam {
      scheduleV2(period: $period) {
        name
        desc
        date
        startTime
        endTime
        address
        room
        building
        classNbr
        link
        typeMod
        buildingInformation {
          description
          campus
          sede
          address
          coordinates {
            longitude
            latitude
          }
        }
        roomInformation {
          building
          type
          floor
        }
      }
    }
  }
`;
